import typoMixin from '@/styles/mixins/typo-mixin'
import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  container: ({ borderRadius }) => css`
    iframe {
      border-radius: ${borderRadius.md};
    }
  `,

  meetingHeader: ({ typography, colors, borderRadius }) => css`
    h3 {
      ${typoMixin({ typography }, 'h3')};
      line-height: 32px;
    }

    ul {
      display: flex;
      gap: 20px;
      margin: 8px 0 16px;

      li {
        display: inline-flex;
        align-items: center;
        ${typoMixin({ typography }, 'h5')};
        color: ${colors.neutral[800]};

        &::before {
          content: '';
          display: inline-flex;
          width: 8px;
          height: 8px;
          margin-right: 8px;
          border-radius: ${borderRadius.circular};
          background-color: ${colors.primary[500]};
        }

        span {
          display: inline-flex;
          margin-left: 4px;
          color: ${colors.extra.gray_icon};
        }
      }
    }
  `,

  chatWrapper: () => css`
    > div {
      height: 100%;
      max-height: 550px;
    }
  `,
})

export { useStyles }
